import React, { useState } from "react";
import ChangePasswordForm from "./ChangePasswordForm";
import Errors from "../../FormItems/error/errors";
import { push } from "connected-react-router";
import actions from "../../../actions/usersFormActions";
import { connect } from "react-redux";

const ChangePasswordFormPage = (props) => {
  const [serverError, setServerError] = useState(null);

  const doSubmit = async (data) => {
    try {
      await props.dispatch(actions.doChangePassword(data));
      setServerError(null);
    } catch (error) {
      const errorMessage = Errors.selectMessage(error);
      setServerError(errorMessage);
    }
  };

  return (
    <React.Fragment>
      <div className="page-top-line">
        <h2 className="page-title">
          User <span className="fw-semi-bold">Password</span>
        </h2>
      </div>
      <ChangePasswordForm
        saveLoading={props.saveLoading}
        findLoading={props.findLoading}
        onSubmit={doSubmit}
        onCancel={() => props.dispatch(push("/admin/users"))}
        serverError={serverError}
      />
    </React.Fragment>
  );
};

function mapStateToProps(store) {
  return {
    findLoading: store.users.form.findLoading,
    saveLoading: store.users.form.saveLoading,
    record: store.users.form.record,
    currentUser: store.auth.currentUser,
  };
}

export default connect(mapStateToProps)(ChangePasswordFormPage);
